import * as api from '../api';
import { SHOW_NOTIFICATIONS } from '../constants/actionTypes';

let defaultSettings = {
    showNotifications: false, 
    showProfileMenu: false, 
    showCreatePost: false, 
    showUserPrompt: false
}

export const showNotificationsAction = (inputData = defaultSettings, cb) => {

    let error = null;

    let data = inputData || {
        ...defaultSettings,
        ...inputData
    }

    let action = {
        type: SHOW_NOTIFICATIONS,
        data
    };  

    if(typeof cb === 'function'){

        cb(error, data);

    }

    return action; 
}